module.exports = __webpack_public_path__ + "img/title3.9b921eb6.png";